






import {Component, Vue} from 'vue-property-decorator';
import StoreBody from "@/components/StoreBody.vue";
@Component({
    components: {StoreBody}
})
export default class Store extends Vue {}
